import React from 'react';
import { Truck } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Input } from '../ui/input';
import { Label } from '../ui/label';

const METHODS = ['Ground', '2-Day', 'Next Day Air', 'LTL Freight', 'FTL Freight', 'Courier', 'Vendor Delivery', 'Will Call / Pickup'];
const TERMS = ['Prepaid', 'Prepaid & Add', 'Collect', 'Third Party', 'FOB Origin', 'FOB Destination'];
const sel = 'w-full h-9 border border-slate-200 rounded-sm px-2 text-sm bg-white';

export const PoShippingCard = ({ form, setForm, carriers, editable }) => {
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });
  const pickCarrier = (e) => {
    const c = carriers.find(x => x.id === e.target.value);
    setForm({ ...form, carrier_id: e.target.value, freight_terms: form.freight_terms || c?.default_freight_terms || '' });
  };
  return (
    <Card className="industrial-card" data-testid="po-shipping-card">
      <CardHeader className="border-b border-slate-100 pb-3"><CardTitle className="text-base flex items-center gap-2"><Truck className="w-4 h-4" /> Shipping</CardTitle></CardHeader>
      <CardContent className="p-4 grid md:grid-cols-4 gap-3">
        <div><Label>Carrier</Label>
          <select value={form.carrier_id || ''} onChange={pickCarrier} disabled={!editable} className={sel} data-testid="po-carrier-select">
            <option value="">— none —</option>{carriers.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
          </select>
        </div>
        <div><Label>Shipping Method</Label>
          <Input list="po-ship-methods" value={form.shipping_method || ''} onChange={set('shipping_method')} disabled={!editable} placeholder="e.g. Ground" className="rounded-sm" data-testid="po-shipping-method" />
          <datalist id="po-ship-methods">{METHODS.map(m => <option key={m} value={m} />)}</datalist>
        </div>
        <div><Label>Freight Terms</Label>
          <Input list="po-freight-terms" value={form.freight_terms || ''} onChange={set('freight_terms')} disabled={!editable} placeholder="e.g. Prepaid" className="rounded-sm" data-testid="po-freight-terms" />
          <datalist id="po-freight-terms">{TERMS.map(m => <option key={m} value={m} />)}</datalist>
        </div>
        <div><Label>Shipping Cost ($)</Label>
          <Input type="number" min="0" step="0.01" value={form.shipping_cost} onChange={set('shipping_cost')} disabled={!editable} className="rounded-sm mono text-right" data-testid="po-shipping" />
        </div>
      </CardContent>
    </Card>
  );
};

export default PoShippingCard;
